<script setup lang="ts">
import { usePageTitle } from '@/composables/usePageTitle.ts'
import { WIDGET_ASSISTANT_IFRAME_MOBILE } from '@/config/visual.const.ts'
import { API_WIDGET_URL } from '@/config/env.const.ts'
import { useUserStore } from '@/stores/user.store.ts'
import { storeToRefs } from 'pinia'
import { onMounted, onUnmounted } from 'vue'
import { TrashIcon } from '@heroicons/vue/20/solid'
import { useTranslations } from '@/composables/useTranslations.ts'
const { t } = useTranslations()

const userStore = useUserStore()
const { projectSelected } = storeToRefs(userStore)
const widgetScriptId = 'crowdy-playground-script'

usePageTitle('Playground')

onMounted(() => {
  var script = document.createElement('script')
  script.src = `${API_WIDGET_URL}/widget.js`
  script.id = widgetScriptId
  script.setAttribute('crowdy-project-key', 'tetlt')
  script.setAttribute('auto-open-delay-ms', '500')
  script.setAttribute('collapsed-if-width-less', '640')

  document.body.appendChild(script)
})

onUnmounted(() => {
  document.getElementsByClassName('crowdy-ai-iframe')[0]?.remove()
  document.getElementById(widgetScriptId)?.remove()
})

function onReloadPageButtonClicked () {
  // localStorage.removeItem('CROWDY_CHAT_DATA') Possible reset messages using iframe.postMessage
  window.location.reload()
}
</script>

<template>
  <div class="flex flex-col items-center justify-center text-center mt-6">
    <button
      @click="onReloadPageButtonClicked"
      type="button"
      class="inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
    >
      <TrashIcon class="-ml-0.5 size-5" aria-hidden="true" />
      {{ t('playground.reloadPage') }}
    </button>
  </div>
</template>
